import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
  DatePicker,
  List,
} from "antd-mobile";
import moment from "moment";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const HomePage = styled.div`
  .taps1 {
    width: 100%;
    padding: 10px;
    // height:150px;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
    margin-top: 10px;
  }
  .taps1 p {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    color: #595755;
  }
  .chuqin {
    padding: 0 20px 0 20px;
    margin-top: 10px;
  }
  .chuqin3 {
    border: 1px solid #e1e1e1;
    padding: 5px 10px 5px 10px;
    border-radius: 5px;
    margin-top: 10px;
  }
  .chuqin3 .line {
    width: 100%;
    height: 1px;
    background-color: #999393;
  }
  .chuqin p {
    display: flex;
    justify-content: space-between;
  }
  .month_wages {
    padding: 10px;
    width: 100%;
    border: 1px solid #999393;
    border-radius: 5px;
    margin-top: 10px;
  }
  .month_wages p {
    display: flex;
    justify-content: space-between;
  }
  .Rank {
    padding: 0 10px 0 10px;
  }
  .Rank1 {
    padding: 10px;
    border: 1px solid #999393;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 10px;
  }
  .Rank1 p {
    display: flex;
    justify-content: space-between;
  }
`;
// 积分查询
interface integralArray {
  consumptionTime: string;
  surplus: string;
  rank: string;
  beforeConsumption: string;
  afterConsumption: string;
}
//培训信息查询
interface trainlArray {
  certificateName: string;
  startTime: string;
  trainingTime: string;
  site: string;
  rate: string;
}
//职级信息查询
interface rankArray {
  jobName: string;
  postName: string;
  rank: string;
  payrollName: string;
  actual: string;
  startTime: string;
  endTime: string;
}
interface detailsArray {
  name: string;
}
interface jxArray {
  examTime: string;
  score: string;
  evaluationCoefficient: string;
  actualPerformance: number;
  taxPersonal: number;
}
interface jx1Array {
  score: string;
  level: string;
  integral: string;
  actualPerformance: string;
  coefficient: string;
  aYear: string;
}
//工资条
interface PayslipArray {
  岗位工资: string;
  全勤工资: string;
  加班工资: string;
  应发工资: string;
  独生子女费: string;
  扣公积金: string;
  扣社保: string;
  扣年金: string;
  扣房租: string;
  实发工资: string;
  salaryPerformance: string; //绩效
  teachFee: string; //讲课费与稿酬
  elseFee: string; //其他
  shouldPerformance: string; //应发绩效
  taxPersonal: string; //扣税
  actualPerformance: string; //实发绩效
}
export default function MyqueryList() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const [integralList, setIntegralList] = useState<integralArray[]>([]);
  const [trainlList, setTrainlList] = useState<trainlArray[]>([]);
  const [ranklList, setRanklList] = useState<rankArray[]>([]);
  const [dateValue, setDateValue] = useState<Date>();
  const [detailsList, setDetailsList] = useState<detailsArray[]>([]);

  useEffect(() => {
    instance
      .get(`/oa/integralInformation/getIntegralInformationList`)
      .then((resp) => {
        // console.log(resp)
        // console.log(resp.data.Data)
        if (resp.data.Status === "1") {
          setIntegralList(resp.data.Data.data);
        }
      });
  }, []);
  //培训信息查询
  const [keyword1, setKeyword1] = useState<string>();
  useEffect(() => {
    instance
      .get(`/oa/trainingInformation/getTrainingInformationList`)
      .then((resp) => {
        if (resp.data.Status === "1") {
          setTrainlList(resp.data.Data.data);
        }
      });
  }, []);
  // 培训信息查询搜索
  const searchBarChange1 = useCallback((keyword1) => {
    instance
      .get(
        `/oa/trainingInformation/getTrainingInformationList?mobileParam=` +
          keyword1
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setTrainlList(resp.data.Data.data);
        }
      });
  }, []);
  const noSearch1 = useCallback(() => {
    instance
      .get(`/oa/trainingInformation/getTrainingInformationList`)
      .then((resp) => {
        if (resp.data.Status === "1") {
          setTrainlList(resp.data.Data.data);
        }
      });
  }, []);

  useEffect(() => {
    instance
      .get(`/oa/employmentInformation/getEmploymentInformationList`)
      .then((resp) => {
        // console.log(resp)
        // console.log(resp.data.Data)
        if (resp.data.Status === "1") {
          setRanklList(resp.data.Data.data);
        }
      });
  }, []);
  useEffect(() => {
    // console.log(dateValue)
    let selectTime = moment(dateValue).format("YYYY-MM-DD HH:mm:ss");
    // console.log(selectTime)
    let selectTimes = selectTime.substring(0, 10);
    instance
      .post(
        `/oa/attendanceManage/attendance/getMyAttendanceByDay?attendanceDate=${selectTimes}`
      )
      .then((resp) => {
        // console.log(resp)
        // console.log(resp.data.Data)
        if (resp.data.Status === "1") {
          setDetailsList(resp.data.Data);
        }
      });
    // console.log(selectTimes)
  }, [dateValue]);
  const tabs = [
    { title: "绩效查询" },
    { title: "考勤查询" },
    { title: "工资条查询" },
    { title: "职级信息查询" },
    { title: "培训信息查询" },
    { title: "积分信息查询" },
  ];
  const tabs1 = [{ title: "月度工资查询" }, { title: "年度工资查询" }];
  const tabs0 = [{ title: "月度绩效查询" }, { title: "年度绩效查询" }];
  const [achievementsList, setAchievementsList] = useState<jxArray[]>([]); //月度绩效查询
  const [achievements1List, setAchievements1List] = useState<jx1Array[]>([]); //年度绩效查询
  const [keyword, setKeyword] = useState<string>();
  const [keywordYear, setKeywordYear] = useState<string>();
  // 月度绩效查询
  useEffect(() => {
    instance.get(`/oa/performance/getMonthPerformanceList`).then((resp) => {
      if (resp.data.Status === "1") {
        setAchievementsList(resp.data.Data.data);
      }
    });
  }, []);
  // 月度绩效查询搜索
  const searchBarChange = useCallback((keyword) => {
    instance
      .get(`/oa/performance/getMonthPerformanceList?mobileParam=` + keyword)
      .then((resp) => {
        if (resp.data.Status === "1") {
          setAchievementsList(resp.data.Data.data);
        }
      });
  }, []);
  const noSearch = useCallback(() => {
    instance.get(`/oa/performance/getMonthPerformanceList`).then((resp) => {
      if (resp.data.Status === "1") {
        setAchievementsList(resp.data.Data.data);
      }
    });
  }, []);
  //年度绩效查询
  useEffect(() => {
    instance.get(`/oa/performance/getYearPerformanceList`).then((resp) => {
      // console.log(resp);
      if (resp.data.Status === "1") {
        setAchievements1List(resp.data.Data.data);
      }
    });
  }, []);
  //年度绩效搜索
  const jxyearChange = useCallback((keywordYear) => {
    instance
      .get(`/oa/performance/getYearPerformanceList?mobileParam=` + keywordYear)
      .then((resp) => {
        if (resp.data.Status === "1") {
          setAchievements1List(resp.data.Data.data);
        }
      });
  }, []);
  const jxyearnoSearch = useCallback(() => {
    instance.get(`/oa/performance/getYearPerformanceList`).then((resp) => {
      if (resp.data.Status === "1") {
        setAchievements1List(resp.data.Data.data);
      }
    });
  }, []);
  //工资条查询
  const year = moment().year();
  const month = moment().month();
  const [payslipList, setPayslipList] = useState<PayslipArray[]>([]);
  const [payslipyearList, setPayslipyearList] = useState<PayslipArray[]>([]);

  const [textyear, setTextyear] = useState<number>();
  const [textmonth, setTextmonth] = useState<number>();

  const [textyear1, setTextyear1] = useState<number>();

  const [payslipValue, setPayslipValue] = useState<Date>(); //月
  const [payslipyearValue, setPayslipyearValue] = useState<Date>(); //年
  //月份工资条
  useEffect(() => {
    // console.log(payslipValue);
    let yearShow = year;
    let monthShow = month;
    // console.log(yearShow, monthShow);
    setTextyear(yearShow);
    setTextmonth(monthShow);
    instance
      .get(
        `/oa/salarySheet/getMonthSalarySheetList?permissionType=me&mobileParam=` +
          yearShow +
          "-" +
          monthShow
      )
      .then((resp) => {
        // console.log(resp);
        if (resp.data.Status === "1") {
          setPayslipList(resp.data.Data.data);
        }
      });
  }, []);
  const payslipChange = useCallback(
    (date) => {
      // console.log(date);
      let selectTime = moment(date).format("YYYY-MM-DD HH:mm:ss");
      let selectMonth = selectTime.substring(0, 7);
      let Year = parseInt(selectTime.substring(0, 4));
      let Month = parseInt(selectTime.substring(5, 7));
      setTextyear(Year);
      setTextmonth(Month);
      instance
        .get(
          `/oa/salarySheet/getMonthSalarySheetList?permissionType=me&mobileParam=` +
            selectMonth
        )
        .then((resp) => {
          // console.log(resp);
          if (resp.data.Status === "1") {
            setPayslipList(resp.data.Data.data);
          }
        });
    },
    [payslipValue]
  );
  //年度工资条
  useEffect(() => {
    // console.log(payslipValue);
    let yearShow = year - 1;
    // console.log(yearShow);
    setTextyear1(yearShow);
    instance
      .get(
        `/oa/salarySheet/getYearSalarySheetList?permissionType=me&mobileParam=` +
          2021
      )
      .then((resp) => {
        // console.log(resp);
        if (resp.data.Status === "1") {
          if (resp.data.Data.data.length > 0) {
            setPayslipyearList(resp.data.Data.data);
          }
        }
      });
  }, []);
  const payslipyearChange = useCallback(
    (date) => {
      console.log(date);
      let selectTime = moment(date).format("YYYY-MM-DD HH:mm:ss");
      let Year = parseInt(selectTime.substring(0, 4));
      setTextyear1(Year);
      instance
        .get(
          `/oa/salarySheet/getMonthSalarySheetList?permissionType=me&mobileParam=` +
            Year
        )
        .then((resp) => {
          // console.log(resp);
          if (resp.data.Status === "1") {
            setPayslipyearList(resp.data.Data.data);
          }
        });
    },
    [payslipyearValue]
  );
  return (
    <>
      <HomePage>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  history.push(`/hr/index`);
                }}
              />
            }
          >
            我的查询
          </NavBar>
          <WhiteSpace />
          <Tabs
            tabs={tabs}
            renderTabBar={(props) => <Tabs.DefaultTabBar {...props} page={4} />}
          >
            {/* 绩效查询 1*/}
            <div>
              <Tabs tabs={tabs0} initialPage={"t2"}>
                {/* 月度绩效查询 */}
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "10px 20px 10px 20px",
                  }}
                >
                  <SearchBar
                    value={keyword}
                    onChange={(value) => setKeyword(value)}
                    placeholder="请输入搜索年月"
                    className="margin"
                    onSubmit={() => {
                      searchBarChange(keyword);
                    }}
                    onCancel={() => {
                      noSearch();
                    }}
                  />
                  <div style={{ padding: "0 10px 0 10px" }}>
                    {achievementsList.map((item) => (
                      <div className="taps1">
                        <p>
                          <span>{item.examTime}</span>
                          <span
                            className="s1"
                            onClick={() => {
                              window.location.href =
                                "/hr/achievements?examTime=" + item.examTime;
                            }}
                          >
                            详情&gt;
                          </span>
                        </p>
                        <p>
                          <span>绩效考核得分:</span>
                          <span>{item.score}</span>
                        </p>
                        <p>
                          <span>月度工作评价系数:</span>
                          <span>{item.evaluationCoefficient}</span>
                        </p>
                        <p>
                          <span>月度绩效金额（元）:</span>
                          <span>{item.actualPerformance}</span>
                        </p>
                        <p>
                          <span>月度绩效扣除金额（元）:</span>
                          <span>{item.taxPersonal}</span>
                        </p>
                      </div>
                    ))}
                  </div>
                  {achievementsList.length === 0 && (
                    <div style={{ textAlign: "center", marginTop: 10 }}>
                      <span>暂无更多数据</span>
                    </div>
                  )}
                </div>
                {/* 年度绩效查询*/}
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "10px 20px 10px 20px",
                  }}
                >
                  <SearchBar
                    value={keywordYear}
                    onChange={(value) => setKeywordYear(value)}
                    placeholder="请输入搜索年份"
                    className="margin"
                    onSubmit={() => {
                      jxyearChange(keywordYear);
                    }}
                    onCancel={() => {
                      jxyearnoSearch();
                    }}
                  />
                  <div style={{ padding: "0 10px 0 10px" }}>
                    {achievements1List.map((item) => (
                      <div className="taps1">
                        <p>
                          <span>{item.aYear}</span>
                        </p>
                        <p>
                          <span>绩效考核得分:</span>
                          <span>{item.score}</span>
                        </p>
                        <p>
                          <span>绩效考核:</span>
                          <span>{item.level}</span>
                        </p>
                        <p>
                          <span>绩效系数:</span>
                          <span>{item.coefficient}</span>
                        </p>
                        <p>
                          <span>绩效积分:</span>
                          <span>{item.integral}</span>
                        </p>
                        <p>
                          <span>年度绩效金额（元）:</span>
                          <span>{item.actualPerformance}</span>
                        </p>
                      </div>
                    ))}
                  </div>
                  {achievements1List.length == 0 && (
                    <div style={{ textAlign: "center", marginTop: 10 }}>
                      <span>暂无更多数据</span>
                    </div>
                  )}
                </div>
              </Tabs>
            </div>
            {/* 考勤查询 2*/}
            <div className="chuqin">
              <div className="chuqin1">
                <p style={{ display: "flex", justifyContent: "space-between" }}>
                  <span style={{ visibility: "hidden" }}>月度明细</span>
                  <DatePicker
                    mode="date"
                    title="Select Date"
                    extra="Optional"
                    value={dateValue}
                    onChange={(date) => {
                      // console.log(date)
                      setDateValue(date);
                    }}
                  >
                    <span style={{}}>
                      {moment(dateValue)
                        .format("YYYY-MM-DD HH:mm:ss")
                        .substring(0, 10)}
                    </span>
                  </DatePicker>
                  <span
                    style={{}}
                    onClick={() => {
                      window.location.href = "/hr/attendance";
                    }}
                  >
                    月度明细
                  </span>
                </p>
                {/* <div style={{ width: '100%', height: 60, backgroundColor: "#108ee9", }}></div> */}
              </div>
              <div className="chuqin3">
                <span>考勤详情</span>
                {detailsList.length > 0 && (
                  <>
                    <p>
                      <span>上午：</span>
                      <span>{detailsList[0].name}</span>
                    </p>
                    <div className="line"></div>
                    <p>
                      <span>下午：</span>
                      <span>{detailsList[1].name}</span>
                    </p>
                  </>
                )}
                {detailsList.length === 0 && (
                  <>
                    <p>
                      <span>上午：</span>
                      <span>暂无数据</span>
                    </p>
                    <div className="line"></div>
                    <p>
                      <span>下午：</span>
                      <span>暂无数据</span>
                    </p>
                  </>
                )}
              </div>
            </div>
            {/* 工资条查询 3*/}
            <div>
              <Tabs tabs={tabs1} initialPage={"t2"}>
                {/* 月度工资查询 */}
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "10px 20px 10px 20px",
                  }}
                >
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <DatePicker
                      mode="month"
                      title="请选择月份"
                      extra="Optional"
                      maxDate={new Date(year, month - 1)}
                      onChange={(date) => {
                        // console.log(date);
                        setPayslipValue(date);
                        payslipChange(date);
                      }}
                    >
                      <span style={{}}>
                        {textyear}年{textmonth}月
                      </span>
                    </DatePicker>
                  </div>
                  {payslipList.map((item) => (
                    <div className="month_wages">
                      <p>
                        <span>岗位工资</span>
                        <span>{item.岗位工资}元</span>
                      </p>
                      <p>
                        <span>全勤工资</span>
                        <span>{item.全勤工资}元</span>
                      </p>
                      <p>
                        <span>加班工资</span>
                        <span>{item.加班工资}元</span>
                      </p>
                      <p>
                        <span>应发工资</span>
                        <span>{item.应发工资}元</span>
                      </p>
                      <p>
                        <span>独生子女费</span>
                        <span>{item.独生子女费}元</span>
                      </p>
                      <p>
                        <span>扣公积金</span>
                        <span>{item.扣公积金}元</span>
                      </p>
                      <p>
                        <span>扣社保</span>
                        <span>{item.扣社保}元</span>
                      </p>
                      <p>
                        <span>扣年金</span>
                        <span>{item.扣年金}元</span>
                      </p>
                      <p>
                        <span>扣房租</span>
                        <span>{item.扣房租}元</span>
                      </p>
                      <p>
                        <span>实发工资</span>
                        <span>{item.实发工资}元</span>
                      </p>
                      <p>
                        <span>绩效</span>
                        <span>{item.salaryPerformance}元</span>
                      </p>
                      <p>
                        <span>讲课费与稿酬</span>
                        <span>{item.teachFee}元</span>
                      </p>
                      <p>
                        <span>其他</span>
                        <span>{item.elseFee}元</span>
                      </p>
                      <p>
                        <span>应发绩效</span>
                        <span>{item.shouldPerformance}元</span>
                      </p>
                      <p>
                        <span>扣税金</span>
                        <span>{item.taxPersonal}元</span>
                      </p>
                      <p>
                        <span>实发绩效</span>
                        <span>{item.actualPerformance}元</span>
                      </p>
                    </div>
                  ))}
                  {payslipList.length !== 1 && (
                    <div className="month_wages">
                      <p>
                        <span>岗位工资</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>全勤工资</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>加班工资</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>应发工资</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>独生子女费</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>扣公积金</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>扣社保</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>扣年金</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>扣房租</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>实发工资</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>绩效</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>讲课费与稿酬</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>其他</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>应发绩效</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>扣税金</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>实发绩效</span>
                        <span>暂无数据</span>
                      </p>
                    </div>
                  )}
                </div>
                {/* 年度工资查询*/}
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "10px 20px 10px 20px",
                  }}
                >
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <DatePicker
                      mode="year"
                      title="请选择年份"
                      extra="Optional"
                      maxDate={new Date(year, month - 1)}
                      onChange={(date) => {
                        console.log(date);
                        setPayslipyearValue(date);
                        payslipyearChange(date);
                      }}
                    >
                      <span style={{}}>{textyear1}年</span>
                    </DatePicker>
                  </div>
                  {payslipyearList.map((item) => (
                    <div className="month_wages">
                      <p>
                        <span>应发年度绩效</span>
                        <span>{item.shouldPerformance}</span>
                      </p>
                      <p>
                        <span>扣税金</span>
                        <span>{item.actualPerformance}元</span>
                      </p>
                      <p>
                        <span>实发年度绩效</span>
                        <span>{item.taxPersonal}元</span>
                      </p>
                    </div>
                  ))}
                  {payslipyearList.length == 0 && (
                    <div className="month_wages">
                      <p>
                        <span>应发年度绩效</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>扣税金</span>
                        <span>暂无数据</span>
                      </p>
                      <p>
                        <span>实发年度绩效</span>
                        <span>暂无数据</span>
                      </p>
                    </div>
                  )}
                </div>
              </Tabs>
            </div>
            {/* 职级信息查询 4*/}
            <div className="Rank">
              {ranklList.map((item) => (
                <div className="Rank1" style={{ marginTop: 10 }}>
                  <div>
                    <span>2021-09-06</span>
                    <span style={{ marginLeft: 10 }}>09:00:00</span>
                  </div>
                  <p>
                    <span>工作序列</span>
                    <span>{item.jobName}</span>
                  </p>
                  <p>
                    <span>岗位</span>
                    <span>{item.postName}</span>
                  </p>
                  <p>
                    <span>职级</span>
                    <span>{item.rank}</span>
                  </p>
                  <p>
                    <span>薪档</span>
                    <span>{item.payrollName}</span>
                  </p>
                  <p>
                    <span>薪档岗位工资</span>
                    <span>{item.actual}</span>
                  </p>
                  <p>
                    <span>任职开始时间</span>
                    <span>{item.startTime.substring(0, 10)}</span>
                  </p>
                  <p>
                    <span>任职结束时间</span>
                    <span>
                      {item.endTime ? item.endTime.substring(0, 10) : "-"}
                    </span>
                  </p>
                  <p>
                    <span>任职批准文件</span>
                    <span style={{ color: "#02a7f0" }}>文件名</span>
                  </p>
                </div>
              ))}

              {ranklList.length === 0 && (
                <div style={{ textAlign: "center", marginTop: 10 }}>
                  <span>暂无数据</span>
                </div>
              )}
            </div>
            {/* 培训信息查询 5*/}
            <div className="Rank">
              <SearchBar
                value={keyword1}
                onChange={(value) => setKeyword1(value)}
                placeholder="请输入项目培训名称"
                className="margin"
                onSubmit={() => {
                  searchBarChange1(keyword1);
                }}
                onCancel={() => {
                  noSearch1();
                }}
              />
              {trainlList.map((item) => (
                <div className="Rank1">
                  <p>
                    <span>项目培训名称</span>
                    <span>{item.certificateName}</span>
                  </p>
                  <p>
                    <span>培训开始时间</span>
                    <span>{item.startTime}</span>
                  </p>
                  <p>
                    <span>培训时长</span>
                    <span>{item.trainingTime}</span>
                  </p>
                  <p>
                    <span>培训地点</span>
                    <span>{item.site}</span>
                  </p>
                  <p>
                    <span>培新结果</span>
                    <span>{item.rate}</span>
                  </p>
                  <p>
                    <span>证书</span>
                    <span style={{ color: "#02a7f0" }}>证书名</span>
                  </p>
                </div>
              ))}
              {trainlList.length === 0 && (
                <div style={{ textAlign: "center", marginTop: 10 }}>
                  <span>暂无更多数据</span>
                </div>
              )}
            </div>
            {/* 积分信息查询 6*/}
            <div>
              <div style={{ padding: "0 10px 0 10px" }}>
                {integralList.map((item) => (
                  <div className="taps1">
                    <p>
                      <span>积分消费时间</span>
                      <span>{item.consumptionTime}</span>
                    </p>
                    <p>
                      <span>剩余积分</span>
                      <span>{item.surplus}</span>
                    </p>
                    <p>
                      <span>职级</span>
                      <span>{item.rank}</span>
                    </p>
                    <p>
                      <span>消费前薪档</span>
                      <span>{item.beforeConsumption}</span>
                    </p>
                    <p>
                      <span>消费后薪档</span>
                      <span>{item.afterConsumption}</span>
                    </p>
                  </div>
                ))}
              </div>
              {integralList.length === 0 && (
                <div style={{ textAlign: "center", marginTop: 10 }}>
                  <span>暂无数据</span>
                </div>
              )}
            </div>
          </Tabs>
          <WhiteSpace />
        </div>
      </HomePage>
    </>
  );
}
